export const hostelroomType = [
  {
    key: "1",
    id: "RT846235",
    roomType: "One Bed",
    description:
      "Enjoy serene solitude in our one-bed room, your tranquil retreat for  focused studying",
  },
  {
    key: "2",
    id: "RT846234",
    roomType: "One Bed AC",
    description:
      "Stay cool and focused in our one-bed AC room, your serene study haven",
  },
  {
    key: "3",
    id: "RT846233",
    roomType: "Two Bed",
    description:
      "Study together in comfort and camaraderie in our two-bed room",
  },
  {
    key: "4",
    id: "RT846232",
    roomType: "Two Bed AC",
    description:
      "Stay cool and study together in comfort in our two-bed AC room",
  },
  {
    key: "5",
    id: "RT846231",
    roomType: "Three Bed",
    description:
      "Study comfortably in our spacious three-bed room, share learning and camaraderie",
  },
  {
    key: "6",
    id: "RT846230",
    roomType: "Three Bed AC",
    description:
      "Experience collaborative studying in comfort with our three-bed AC room",
  },
  {
    key: "7",
    id: "RT846229",
    roomType: "Four Bed",
    description:
      "Engage in group study sessions and foster camaraderie in our spacious four-bed room",
  },
  {
    key: "8",
    id: "RT846228",
    roomType: "Four Bed AC",
    description:
      "Experience collaborative study sessions in comfort with our spacious four-bed AC room",
  },
  {
    key: "9",
    id: "RT846227",
    roomType: "Five Bed",
    description:
      "Foster teamwork and academic synergy, ideal for group study sessions",
  },
  {
    key: "10",
    id: "RT846226",
    roomType: "Five Bed AC",
    description:
      "Optimal comfort meets collaborative studying, perfect for academic synergy among residents.",
  },
];
